import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import * as dynamicActionTypes from 'state/dynamic/dynamicForm.actionTypes';
import { addOrPatchKey, addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { Action } from '../../actions';
import type { QuoteDetailUiState } from './quoteDetail.model';
import { initialQuoteDetailUiState } from './quoteDetail.model';

export function quoteDetailUiReducer(state: QuoteDetailUiState = {}, action: Action): QuoteDetailUiState {
  switch (action.type) {
    case 'QUOTE_REQUESTED':
    case 'PREVIOUS_QUOTE_LOADED':
      return addOrReplaceKey(state, action.tabId, initialQuoteDetailUiState);

    case addonActionTypes.ADDON_QUOTE_REQUESTED:
    case dynamicActionTypes.DYNAMIC_BOOKING_REQUESTED:
      return addOrReplaceKey(state, action.tabId, initialQuoteDetailUiState);
    case 'SET_PANEL_QUOTE_INFOS_ACTIVE_TAB':
      return patchKey(state, action.tabId, () => ({ activeTab: action.activeTab }));
    case 'TOGGLE_QUOTE_INFOS_SECTION':
      return addOrPatchKey(state, action.tabId, substate => ({
        ...substate,
        expanded: { ...substate.expanded, [action.section]: !substate.expanded[action.section] },
      }));
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.tabId);
    default:
      return state;
  }
}
